module.exports = __webpack_public_path__ + "c4fa4488.png";